<template>
  <div class="flex h-screen bg-gray-100">
    <!-- MENU LATERAL -->
    <aside class="nav-container w-64 bg-blue-900 text-white flex flex-col p-4 space-y-8">
      <div class="flex items-center">
        <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 mr-2">
        <h1 class="text-1xl font-bold font-serif">AdminGate</h1>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im34.png" class="h-6 w-6 mr-2">
        <router-link to="/dash" class="hover:bg-blue-900 p-2 rounded transition">Dashboard</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im36.png" class="h-6 w-6 mr-2">
        <router-link to="/student" class="hover:bg-blue-900 p-2 rounded transition">Étudiants</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/icour.png" class="h-6 w-6 mr-2">
        <router-link to="/study" class="hover:bg-blue-900 p-2 rounded transition">Cours</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im35.png" class="h-6 w-6 mr-2">
        <router-link to="/event" class="hover:bg-blue-900 p-2 rounded transition">Calendrier</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im33.png" class="h-6 w-6 mr-2">
        <router-link to="/note" class="hover:bg-blue-900 p-2 rounded transition">Évaluations</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im38.png" class="h-6 w-6 mr-2">
        <router-link to="/" class="hover:bg-blue-900 p-2 rounded transition">Logout</router-link>
      </div>
    </aside>

    <main class="flex-1 p-6 overflow-y-auto bg-white">
      <div class="max-w-4xl mx-auto space-y-8 font-serif">
        <div>

             <div class="flex justify-center font-serif">
        <img src="/image/im39.png" class="h-8 w-8 mr-2">
         <h2 class="text-3xl text-blue-900 mb-4">Gestion des étudiants</h2>
      </div>

          <h2 class="text-1xl font-bold mb-4">Ajouter/Modifier un étudiant</h2>
          <form @submit.prevent="ajouterEtudiant" enctype="multipart/form-data" class="flex items-center grid grid-cols-2 gap-4 bg-transparent-500 p-6 rounded shadow">
            <input v-model="form.name" placeholder="Nom" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.surname" placeholder="Prénom" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.email" placeholder="Email" required type="email" class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.matricule" placeholder="Matricule" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.password" placeholder="Mot de passe" type="password" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.niveau" placeholder="Niveau" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />

            <select v-model="form.role" class=" border p-2 rounded col-span-2 border-b-2 border-gray-300 bg-transparent focus:outline-none">
              <option value="eleve">Élève</option>
              <option value="admin">Admin</option>
            </select>
            
                    <div class="col-span-2 flex items-center space-x-2">
            <label class="font-medium">Photo :</label>
            <input type="file" @change="handleImage" />
            </div>

            <div class="col-span-2 flex justify-center">
                        <button type="submit" class="w-[100px] h-8 bg-blue-900 text-white rounded hover:bg-blue-800 transition duration-300">
                            {{ isEditing ? "Modifier" : "Ajouter" }}
                        </button>
                        <button v-if="isEditing" type="button" @click="annulerModification" class="ml-4 w-[100px] h-8 bg-gray-500 text-white rounded hover:bg-gray-600 transition duration-300">
                            Annuler
                        </button>
            </div>
          </form>
        </div>

        <div>
          <h2 class="text-1xl font-bold mb-4 font-serif">Liste des étudiants</h2>
          
          <table class="min-w-full bg-white rounded shadow font-serif">
            <thead>
              <tr class="bg-blue-900 text-left text-white font-serif">
                <th class="py-2 px-4">Nom</th>
                <th class="py-2 px-4">Prénom</th>
                <th class="py-2 px-4">Email</th>
                <th class="py-2 px-4">Matricule</th>
                <th class="py-2 px-4">Niveau</th>
                <th class="py-2 px-4">Rôle</th>
                <th class="py-2 px-4">Actions</th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="etudiant in etudiants" :key="etudiant.id" class="border-b font-serif">
                <td class="py-2 px-4">{{ etudiant.name }}</td>
                <td class="py-2 px-4">{{ etudiant.surname }}</td>
                <td class="py-2 px-4">{{ etudiant.email }}</td>
                <td class="py-2 px-4">{{ etudiant.matricule }}</td>
                <td class="py-2 px-4">{{ etudiant.niveau }}</td>
                <td class="py-2 px-4">{{ etudiant.role }}</td>
                <td class="py-2 px-4 flex space-x-2">
                <button @click="editerEtudiant(etudiant)">
    <img src="/image/im40.png" alt="Modifier" class="w-5 h-5 hover:scale-110 transition" />
  </button>

  <!-- Bouton Supprimer -->
  <button @click="supprimerEtudiant(etudiant.id)">
    <img src="/image/im41.png" alt="Supprimer" class="w-5 h-5 hover:scale-110 transition" />
  </button>
                 </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>

  <footer class="nav-container py-4 text-center text-sm text-gray-300 font-serif">
     &copy; 2025 University StudentGate — Tous droits réservés.
   </footer>
</template>


<script>
import axios from 'axios'

export default {
  name: 'StudentView',
  data() {
    return {
      form: {
        name: '',
        surname: '',
        email: '',
        matricule: '',
        password: '',
        niveau: '',
        role: 'eleve',
        image: null,
      },
      etudiants: []
    }
  },
  mounted() {
    this.getEtudiants()
  },
  methods: {

    editerEtudiant(etudiant) {
    this.form = { ...etudiant }; 
    this.isEditing = true;
  },


  supprimerEtudiant(id) {
    if (confirm("Voulez-vous vraiment supprimer cet étudiant ?")) {
      axios.delete(`https://mida-back.onrender.com/api/users/${id}`)
        .then(() => {
          this.etudiants = this.etudiants.filter(e => e.id !== id);
        }) 
       
        .catch(error => {
          console.error("Erreur lors de la suppression :", error);
        });
         alert('Étudiant supprimé avec succès !')
    }
  },


    handleImage(event) {
      this.form.image = event.target.files[0]
    },
    async ajouterEtudiant() {
      const formData = new FormData()
      for (const key in this.form) {
        formData.append(key, this.form[key])
      }

      try {
        await axios.post('https://mida-back.onrender.com/api/register', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        alert('Étudiant ajouté avec succès !')
        this.getEtudiants()
      } catch (error) {
        alert('Erreur lors de l\'ajout')
        console.error(error.response.data)
      }
    },
    async getEtudiants() {
      try {
        const response = await axios.get('https://mida-back.onrender.com/api/users') 
        this.etudiants = response.data
      } catch (error) {
        console.error('Erreur récupération étudiants', error)
      }
    }
  }
}
</script>

<style scoped>
.nav-container {
  background-color: #163767;
}

.container {
  max-width: 800px;
  margin: auto;
}
input, select {
  display: block;
  margin: 5px 0;
  padding: 8px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
th, td {
  border: 1px solid #ddd;
  padding: 8px;
}
</style>
